import Md from 'mobile-detect';
import { Subject, BehaviorSubject } from 'rxjs';

type ListenerEventType = 'deviceorientation' | 'devicemotion';
type ListenerEvent = DeviceOrientationEvent | DeviceMotionEvent | any;

/** 设备相关服务 */
class DvService {
  md = new Md(window.navigator.userAgent);
  isWX = this.md.match('MicroMessenger');
  isWb = this.md.match('WeiBo');

  eventListenerObject$: BehaviorSubject<{ type: ListenerEventType; e: ListenerEvent }> = new BehaviorSubject(null as any);

  permissionState: any = {};

  /** 依据事件名添加全局监听事件 */
  listenerEvent(type: ListenerEventType) {
    if (this.permissionState[type]) return; // 防止重复发送
    this.permissionState[type] = true;
    window.addEventListener(type, e => {
      if (e instanceof DeviceMotionEvent) e = this.formatMotionData(e);
      this.eventListenerObject$.next({ type, e });
    });
  }

  /** 请求设备事件监听 */
  requestPermissionsIOS(type: ListenerEventType) {
    if (typeof DeviceMotionEvent === 'undefined') return;
    if (typeof (DeviceMotionEvent as any).requestPermission === 'function') {
      (DeviceMotionEvent as any)
        .requestPermission()
        .then(permissionState => {
          if (permissionState === 'granted') {
            console.log({ permissionState });
            this.listenerEvent(type);
          } else {
            console.log('用户未授权');
          }
        })
        .catch(console.error);
    } else {
      // handle regular non iOS 13+ devices
      this.listenerEvent(type);
    }
  }

  /** 处理加速度安卓和ios的差异值 */
  formatMotionData(e: DeviceMotionEvent) {
    if (!e.accelerationIncludingGravity) return e;

    let { x, y, z } = e.accelerationIncludingGravity;

    if (x === null) return e;

    const isIOS = this.md.match('iPhone');
    const digit = 10; // 保留小树位数

    /** 限制最大倾斜率和灵敏度 */
    function count(v: number | null) {
      let value = (Math.round(Number(v) * digit) / digit) * 0.5;
      if (value >= 1.5) value = 1.5;
      if (value <= -1.5) value = -1.5;
      return value;
    }

    let data = {
      x: count(x),
      y: count(y),
      z: count(z),
    };

    if (!isIOS) {
      data = {
        x: -data.x,
        y: -data.y,
        z: -data.z,
      };
    }

    // todo 潜拷贝，可能存在问题
    return Object.assign({}, e, { accelerationIncludingGravity: data });
  }
}

/** 单例对象函数 */
const service = (() => {
  // 隐藏的Class的构造函数
  // function TodayCilpService() {}

  // 未初始化的单例对象
  let service: DvService;

  return {
    // 创建/获取单例对象的函数
    getInstance: () => {
      if (!service) {
        service = new DvService();
        console.log('md', service.md);
      }
      return service;
    },
  };
})();
export const dvService = service.getInstance();
